export default __webpack_public_path__ + "static/media/hero_applicant.e0924c00.svg";